import type { AttachmentKind } from '@pet/shared';

// Plain label for a stored document on payment detail, e.g. "Receipt (PDF)".
// `kind` is what the upload slot recorded; null means not recorded (rows written
// before the discriminator existed) and reads as the generic "Document".
// The MIME type only says the file's form: a photo, a PDF, or some other file.
const KIND_WORDS: Record<AttachmentKind, string> = {
  RECEIPT: 'Receipt',
  INVOICE: 'Invoice',
  BANK_RECORD: 'Bank record',
  OTHER: 'Document',
};

function fileForm(mime: string): string {
  const type = mime.split(';')[0].trim().toLowerCase();
  if (type.startsWith('image/')) return 'photo';
  if (type === 'application/pdf') return 'PDF';
  return 'file';
}

export function attachmentLabel(kind: AttachmentKind | null, mime: string): string {
  const word = (kind && KIND_WORDS[kind]) ?? 'Document';
  return `${word} (${fileForm(mime)})`;
}
